// extracted by mini-css-extract-plugin
module.exports = {"input":"iR7V5x","label":"XDY8li","checkbox":"zpgbQU"};